const TOPICS = [
  { id: 1, label: '91国产视频', count: '12.8万', hot: true },
  { id: 2, label: '国产电影', count: '9.6万', hot: true },
  { id: 3, label: '国产电视剧', count: '8.3万', hot: true },
  { id: 4, label: '91年影片', count: '7.1万', hot: false },
  { id: 5, label: '国产综艺', count: '6.5万', hot: true },
  { id: 6, label: '经典回顾', count: '5.9万', hot: false },
  { id: 7, label: '高清影视', count: '5.2万', hot: false },
  { id: 8, label: '纪录片', count: '4.8万', hot: false },
  { id: 9, label: '年代剧', count: '4.3万', hot: false },
  { id: 10, label: '喜剧片', count: '3.9万', hot: false },
  { id: 11, label: '悬疑剧', count: '3.5万', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 mb-3">热门话题</h2>
          <p className="text-sm md:text-base text-foreground-500">大家都在关注的91国产视频内容标签</p>
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          {TOPICS.map((topic) => (
            <span
              key={topic.id}
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full cursor-pointer transition-all text-sm font-medium whitespace-nowrap ${
                topic.hot
                  ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200 border border-background-200'
              }`}
            >
              {topic.hot && <i className="ri-fire-line text-xs"></i>}
              {topic.label}
              <span className={`text-xs ${topic.hot ? 'text-background-50/70' : 'text-foreground-400'}`}>
                {topic.count}
              </span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}